import { io } from "socket.io-client";

export const CUSTOMER_SOCKET_OPTIONS = {
  transports: ["websocket"],
  upgrade: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
  timeout: 10000,
  withCredentials: true,
  path: "/socket.io",
};

export const createCustomerSocket = (url, options = {}) =>
  io(url, {
    ...CUSTOMER_SOCKET_OPTIONS,
    ...options,
  });
